import duxFactory from './fetch-dux-factory';
import * as api from '../api/api'; // TODO: rename/refactor api?

export default {
  simpleExample: duxFactory({
    apiFn: api.getTestMessage,
    actionPrefix: 'GET_TEST_MESSAGE'
  }),
  searchRestaurantsExample: duxFactory({
    apiFn: api.getRestaurants,
    actionPrefix: 'GET_RESTAURANTS'
  }),
  getRestaurantExample: duxFactory({
    apiFn: api.getRestaurant,
    actionPrefix: 'GET_RESTAURANT'
  }),
  patchRestaurantExample: duxFactory({
    apiFn: api.patchRestaurant,
    actionPrefix: 'PATCH_RESTAURANT'
  }),
  getCuisinesExample: duxFactory({
    apiFn: api.getCuisines,
    actionPrefix: 'GET_CUISINES'
  }),
  searchMusicExample: duxFactory({
    apiFn: api.getMusic,
    actionPrefix: 'GET_MUSIC'
  }),
  getAlbumExample: duxFactory({
    apiFn: api.getAlbum,
    actionPrefix: 'GET_ALBUM'
  }),
  patchAlbumExample: duxFactory({
    apiFn: api.patchAlbum,
    actionPrefix: 'PATCH_ALBUM'
  }),
  getArtistsExample: duxFactory({
    apiFn: api.getArtists,
    actionPrefix: 'GET_ARTISTS'
  }),
  login: duxFactory({ apiFn: api.postLogin, actionPrefix: 'POST_LOGIN' }),
  forgotPassword: duxFactory({
    apiFn: api.forgotPassword,
    actionPrefix: 'POST_FORGOT_PASSWORD'
  }),
  resetPassword: duxFactory({
    apiFn: api.resetPassword,
    actionPrefix: 'POST_RESET_PASSWORD'
  }),
  searchAuditLog: duxFactory({
    apiFn: api.getAuditLog,
    actionPrefix: 'GET_AUDIT_LOG'
  }),
  getContent: duxFactory({
    apiFn: api.getContent,
    actionPrefix: 'GET_CONTENT'
  }),
  getKnowledgeCenterArticles: duxFactory({
    apiFn: api.getKnowledgeCenterArticles,
    actionPrefix: 'GET_KNOWLEDGE_CENTER_ARTICLES'
  }),
  checkLoginStatus: duxFactory({
    apiFn: api.checkLoginStatus,
    actionPrefix: 'GET_LOGIN_STATUS'
  }),
  postContactForm: duxFactory({
    apiFn: api.postContactForm,
    actionPrefix: 'POST_CONTACT_FORM'
  })
};



// WEBPACK FOOTER //
// ./src/state/fetch-dux.js